/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'
const BASE_URL = `paas`
export default {
  /**
   * getInvoiceAuditList
   * @description 获取开票审核列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceAuditList(data) {
    return request.post(`/${BASE_URL}/admin_invoice/list`, data)
  },
  /**
   * getInvoiceAuditView
   * @description 获取开票审核申请详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceAuditView(data) {
    return request.post(`/${BASE_URL}/admin_invoice/view`, data)
  },
  /**
   * getInvoiceAuditEdit
   * @description 编辑开票审核
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getInvoiceAuditEdit(data) {
    return request.post(`/${BASE_URL}/admin_invoice/edit`, data)
  },
  /**
   * invoiceAuditDetail
   * @description 开票审核开票详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceAuditDetail(data) {
    return request.post(`/${BASE_URL}/admin_invoice/detail`, data)
  },
  /**
   * invoiceAuditExpressDetails
   * @description 开票审核快递详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceAuditExpressDetails(data) {
    return request.post(`/${BASE_URL}/admin_invoice/express`, data)
  },
   /**
   * invoiceAudit
   * @description 开票审核
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  invoiceAudit(data) {
    return request.post(`/${BASE_URL}/admin_invoice/edit`, data)
  }
}